import React, {ReactElement, ReactNode} from 'react';
import {useIntl} from 'react-intl';
import ErrorMessage from './ErrorMessage';
import AssistiveText from './AssistiveText';
import './Field.scss';
import trimClassname from '../../../../utils/trimClassname';

export interface Props {
  children: ReactNode;
  label?: string;
  name: string;
  assistiveMessage?: ReactNode;
  errorMessage?: ReactNode;
  warningMessage?: ReactNode;
  showOptionalMessage?: boolean;
  isDisabled?: boolean;
  labelClassName?: string;
}

function Field({
  assistiveMessage = '',
  children,
  errorMessage = '',
  label = '',
  name,
  warningMessage = '',
  showOptionalMessage,
  isDisabled,
  labelClassName,
}: Props): ReactElement {
  const {formatMessage} = useIntl();
  return (
    <div
      className={`field ${errorMessage ? 'field--error' : ''} ${warningMessage ? 'field--warning' : ''} ${
        isDisabled ? 'field--disabled' : ''
      }`.trim()}
    >
      {label ? (
        <label
          htmlFor={name}
          className={trimClassname(`label ${isDisabled ? 'label--disabled' : ''} ${labelClassName || ''}`)}
          data-testid={`ui.form.field.label.${name}`}
        >
          {label}
          {showOptionalMessage && (
            <span className="field__optional">&nbsp;{formatMessage({id: 'phoenix.fields.optional'})}</span>
          )}
        </label>
      ) : null}
      {assistiveMessage ? <AssistiveText assistiveMessage={assistiveMessage} /> : null}
      {errorMessage || warningMessage ? (
        <ErrorMessage errorMessage={errorMessage} warningMessage={warningMessage} />
      ) : null}
      {children}
    </div>
  );
}

export default Field;
